import { render, staticRenderFns } from "./Datatable.vue?vue&type=template&id=488d3a4e"
import script from "./Datatable.vue?vue&type=script&lang=js"
export * from "./Datatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('488d3a4e')) {
      api.createRecord('488d3a4e', component.options)
    } else {
      api.reload('488d3a4e', component.options)
    }
    module.hot.accept("./Datatable.vue?vue&type=template&id=488d3a4e", function () {
      api.rerender('488d3a4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Dashboard/Interacciones/Datatable.vue"
export default component.exports